import { Box, Card, CardContent, Grid } from "@mui/material";
import { Clear, Description, Search } from "@mui/icons-material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogDetails from "./modal/dialogDetails";
import IGenericResult from "../../../interfaces/IGenericResult";
import InputNumber from "../../../components/hookForms/inputNumber";
import Tooltip from "@mui/material/Tooltip";
import messages from "../../../utils/messages";
import serviceUsina from "../../../services/serviceUsina";
import { toast } from "react-toastify";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import serviceConcessionaria from "@/services/serviceConcessionaria";

const Usina = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Usinas - Usina");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);

    const [detailsState, setDetailsState] = useState({
        open: false,
        id: "",
        nomeUsina: "",
        energiaKWP: "",
        energiaKWH: "",
        percentualDiferencaAceitavel: "",
        numeroInstalacao: "",
        tipoPesquisa: "",
        codigoProduto: "",
        crUsina: "", //centro de custo
        tipoUsina: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            numeroInstalacao: "",
            usinaID: 0,
            tipoUsina: "",
            diferencaPercentual: "",
            concessionariaID: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 170,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Ver detalhes">
                                <Description />
                            </Tooltip>
                        }
                        label="Ver detalhes"
                        onClick={() =>
                            setDetailsState({
                                open: true,
                                id: params.id.toString(),
                                nomeUsina: params.row.nomeUsina,
                                energiaKWP: params.row.energiaKWP,
                                energiaKWH: params.row.energiaKWH,
                                percentualDiferencaAceitavel: params.row.percentualDiferencaAceitavel,
                                numeroInstalacao: params.row.numeroInstalacao,
                                tipoPesquisa: params.row.tipoPesquisa,
                                codigoProduto: params.row.codigoProduto,
                                crUsina: params.row.crUsina,
                                tipoUsina: params.row.tipoUsina,
                            })
                        }
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "usinaID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Nome",
                field: "nomeUsina",
                type: "string",
                width: 230,
            },
            {
                headerName: "Energia kWp",
                field: "energiaKWP",
                type: "number",
                headerAlign: "left",
                width: 180,
            },
            {
                headerName: "Energia kWh",
                field: "energiaKWH",
                type: "number",
                headerAlign: "left",
                width: 180,
            },
            {
                headerName: "Diferença %",
                field: "percentualDiferencaAceitavel",
                type: "number",
                headerAlign: "left",
                width: 180,
            },
            {
                headerName: "Tipo",
                field: "tipoUsina",
                type: "string",
                width: 180,
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                width: 180,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setUsinaData();
        setConcessionariaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    
    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const tipoUsinaOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Cooperativa", value: "Cooperativa" },
        { label: "Consórcio", value: "Consórcio" },
        { label: "AutoConsumo Remoto", value: "AutoConsumo Remoto" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceUsina
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel, sortModel]
    );

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            tipoUsina: values.tipoUsina === "Todos" ? "" : values.tipoUsina,
            diferencaPercentual: values.diferencaPercentual
                ? Number(values.diferencaPercentual.replaceAll(".", "").replaceAll(",", "."))
                : "",
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClear = () => {
        reset();
        setFilters(null);
        getAllWithFilters(null);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={1.5}>
                                            <InputNumber
                                                name="numeroInstalacao"
                                                label="Instalação"
                                                control={control}
                                                error={errors}
                                                decimalScale={0}
                                                noThousandSeparator
                                                maxLength={15}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={1.5}>
                                            <AutoComplete
                                                name="usinaID"
                                                label="Nome da usina"
                                                options={usinaDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                         <Grid item xs={10} md={1.8}>
                                            <AutoComplete
                                                name="concessionariaID"
                                                label="Concessionária"
                                                options={concessionariaDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={1.5}>
                                            <AutoComplete
                                                name="tipoUsina"
                                                label="Tipo"
                                                options={tipoUsinaOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={1.8}>
                                            <InputNumber
                                                name="diferencaPercentual"
                                                label="Percentual dif. aceitável"
                                                control={control}
                                                error={errors}
                                                decimalScale={2}
                                                maxLength={6}
                                            />
                                        </Grid>

                                        <Grid item md={1.5}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item md={1.5}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.usinaID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogDetails
                        open={detailsState.open}
                        data={{
                            open: detailsState.open,
                            id: detailsState.id,
                            nomeUsina: detailsState.nomeUsina,
                            energiaKWP: detailsState.energiaKWP,
                            energiaKWH: detailsState.energiaKWH,
                            percentualDiferencaAceitavel: detailsState.percentualDiferencaAceitavel,
                            numeroInstalacao: detailsState.numeroInstalacao,
                            tipoPesquisa: detailsState.tipoPesquisa,
                            codigoProduto: detailsState.codigoProduto,
                            crUsina: detailsState.crUsina, //centro de custo
                            tipoUsina: detailsState.tipoUsina,
                        }}
                        onClose={() => {
                            setDetailsState({
                                open: false,
                                id: "",
                                nomeUsina: "",
                                energiaKWP: "",
                                energiaKWH: "",
                                percentualDiferencaAceitavel: "",
                                numeroInstalacao: "",
                                tipoPesquisa: "",
                                codigoProduto: "",
                                crUsina: "", //centro de custo
                                tipoUsina: "",
                            });
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default Usina;
